import { hasRole } from '@bo/constants/userRoles';
import UserService from '@boServices/userService';
import { createContext, useCallback, useContext, useEffect, useState } from 'react';

const userService = new UserService();

const BoAuthContext = createContext({ status: 'loading', user: null, roles: [], hasRole: () => false, setAuthenticated: () => {} });

export const useBoAuth = () => useContext(BoAuthContext);

export const BoAuthProvider = ({ children }) => {
    const [status, setStatus] = useState('loading');
    const [user, setUser] = useState(null);

    // GET /users/me, unlike GET /users, is accessible to every BO role: used both as the auth
    // probe and as the source of the current user's roles. Back to 'loading' while it runs, so that a
    // protected route waits instead of redirecting to the login page right after a sign-in; the
    // returned promise resolves once the status is settled.
    const loadMe = useCallback(() => {
        setStatus('loading');
        return userService
            .getMe()
            .then((me) => {
                setUser(me);
                setStatus('auth');
            })
            .catch(() => {
                setUser(null);
                setStatus('unauth');
            });
    }, []);

    useEffect(() => {
        loadMe();
    }, [loadMe]);

    const roles = user?.roles ?? [];

    return (
        <BoAuthContext.Provider value={{ status, user, roles, hasRole: (role) => hasRole(roles, role), setAuthenticated: loadMe }}>
            {children}
        </BoAuthContext.Provider>
    );
};
